import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@chakra-ui/react';
import { ArrowUpIcon } from '@chakra-ui/icons';

import { useTranslation } from 'helpers/languages/translations';
import { useTabNavigate } from 'router/tabsMapper';

import PageHeader from 'layout/pageHeader';
import ProductTitlesTabs from './ProductTitlesTabs';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';

const PATH = 'product-titles';
const ID = 'cdm_producttitlesplit';
const NAME = 'page.productTitles';

const ProductTitles = () => {
    const translate = useTranslation();
    const navigate = useNavigate();
    const { tabIndex, setTabIndex } = useTabNavigate('product-management');

    const userInfo = useGetUserInfoSelector();
    const readonly = !userInfo?.user_groups?.includes(20);

    return (
        <Box>
            <PageHeader icon={{ name: 'productBis' }} pageTitle={translate(NAME) as string} readonly={readonly}>
                {!/3/.test(`${tabIndex}`) && (
                    <Button
                        fontSize="14px"
                        h="30px"
                        bg={'white'}
                        variant="outline"
                        leftIcon={<ArrowUpIcon />}
                        onClick={() => {
                            navigate('upload');
                        }}
                        isDisabled={readonly}
                    >
                        {translate('file.upload')}
                    </Button>
                )}
            </PageHeader>
            <Box px="32px">
                <ProductTitlesTabs setTabIndex={setTabIndex} index={tabIndex} />
            </Box>
        </Box>
    );
};

export { PATH, ID, NAME };
export default ProductTitles;
